<template>
    <div class="card shadow-sm mb-3">
        <div class="card-header border-bottom py-3 px-3 px-md-4 d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div class="d-flex align-items-center gap-2">
                <span class="cal-header-icon cal-header-icon--blue">
                    <i class="bi bi-clock-history"></i>
                </span>
                <div>
                    <h6 class="mb-0 fw-bold">Versiyalar</h6>
                    <small class="text-muted" style="font-size: 0.78rem;">Sənədin versiya və dəyişiklik tarixçəsi</small>
                </div>
            </div>
            <div class="d-flex align-items-center gap-2">
                <button type="button" class="btn action-btn action-btn--muted" @click="GetLists">
                    <i class="bi bi-arrow-clockwise me-1"></i>
                    <span>Yeniləmək</span>
                </button>
            </div>
        </div>
        <div class="card-body p-0" v-loading="loading">
            <Table :data="data"></Table>
        </div>
    </div>
 
</template>
<script>
import Table from "./Components/Tables/Table.vue"; 


export default {
    components: {
        Table 
    },
    data() {
        return {
            loading: null,
            data: [] 
        }
    },
    methods: {
        GetLists() {
             
        } 
    },
    mounted() {
        this.GetLists()
    }
}
</script>